<template>
  <div
    :class="[
      'form__field-holder',
      {
        'form__field-holder_error': !!errors.has(newName),
        'radio-btn-item': extraStylingIsEnabled,
      },
    ]"
    data-vv-value-path="model"
    :data-vv-as="label ? label : validationLabel"
  >
    <div class="form__field-box">
      <label class="form__label" v-if="label">
        {{ label }}
      </label>
      <input type="hidden" :name="name" v-model="model" v-validate="rules" />
      <template v-if="sort">
        <div
          :class="[
            'v-checkbox',
            {
              'v-checkbox--is-dirty': isDirty,
              'v-checkbox--is-disabled': disabled,
              'v-checkbox--has-label':
                Object.keys(options).length || this.$slots.default,
            },
          ]"
        >
          <label
            :for="name + key"
            class="v-checkbox__item v-checkbox__item--is-radio"
            v-for="(option, key) in sortProperties(options, sortBy, order)"
            :key="option[0]"
            @click="stateChange"
          >
            <input
              @change="$emit('input', model), $emit('change', model)"
              :name="name"
              type="radio"
              :value="option[0]"
              v-model="model"
              :disabled="disabled"
              :id="name + option[0]"
            />
            <div class="v-checkbox__indicator"></div>
            <span v-html="option[1]"></span>
          </label>
        </div>
      </template>
      <div
        v-else
        :class="[
          'v-checkbox',
          {
            'v-checkbox--is-dirty': isDirty,
            'v-checkbox--is-disabled': disabled,
            'v-checkbox--has-label':
              Object.keys(options).length || this.$slots.default,
          },
        ]"
      >
        <label
          :for="name + key"
          class="v-checkbox__item v-checkbox__item--is-radio"
          v-for="(option, key) in options"
          :key="key"
          @click.prevent="
            disableAutoComplete();
            stateChange($event);
          "
        >
          <input
            :name="name"
            type="radio"
            :value="key"
            v-model="model"
            :disabled="disabled"
            :id="name + key"
          />
          <div class="v-checkbox__indicator"></div>
          <span v-html="option"></span>
        </label>
      </div>
    </div>
    <!--     <div class="form__field-error" v-if="errors.has(newName)">
          {{ errors.first(newName) }}
        </div> -->
  </div>
</template>

<script>
import field from "../mixins/field";

export default {
  computed: {
    isDirty() {
      return !!this.model;
    },
  },
  data() {
    return {
      model: this.value,
    };
  },
  mixins: [field],
  methods: {
    stateChange(event) {
      if(!this.disabled){
        var innerInputValue =
          event.target.tagName == "LABEL"
            ? event.target.getElementsByTagName("input")[0].value
            : event.target.parentElement.getElementsByTagName("input")[0].value;

        this.model =
          this.model === innerInputValue
            ? innerInputValue === 0
              ? innerInputValue
              : null
            : innerInputValue;
      }
    },
    disableAutoComplete() {
      let elements = document.querySelectorAll('[autocomplete="off"]');

      if (!elements) {
        return;
      }

      [...elements].forEach((element) => {
        element.setAttribute("readonly", "readonly");

        setTimeout(() => {
          element.removeAttribute("readonly");
        }, 500);
      });
    },
    sortProperties(obj, sortBy, order) {
      var sortable = [];
      for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
          sortable.push([key, obj[key]]);
        }
      }
      if (sortBy == "key") {
        sortable.sort(function (a, b) {
          var x = parseInt(a[0]),
            y = parseInt(b[0]);
          return order == "desc"
            ? x > y
              ? -1
              : x < y
              ? 1
              : 0
            : x < y
            ? -1
            : x > y
            ? 1
            : 0;
        });
      } else if (sortBy == "custom") {
        sortable = this.customOrder;
      } else {
        sortable.sort(function (a, b) {
          var x = a[1].toLowerCase(),
            y = b[1].toLowerCase();
          return order == "desc"
            ? x > y
              ? -1
              : x < y
              ? 1
              : 0
            : x < y
            ? -1
            : x > y
            ? 1
            : 0;
        });
      }
      return sortable; // array in format [ [ key1, val1 ], [ key2, val2 ], ... ]
    },
  },
  props: {
    label: {
      default() {
        return "";
      },
      type: String,
    },
    validationLabel: {
      default: "",
      type: String,
    },
    options: {
      default: () => {
        return {};
      },
      type: [Object, Array],
    },
    value: {
      default: null,
      type: [Number, String, Array],
    },
    extraStylingIsEnabled: {
      default: false,
      type: Boolean,
    },
    sort: {
      default: false,
      type: Boolean,
    },
    sortBy: {
      default: "key",
      type: String,
    },
    order: {
      default: "asc",
      type: String,
    },
    customOrder: {
      default: () => {
        return {};
      },
      type: [Object, Array],
    },
    disabled: {
      default: false,
      type: Boolean,
    },
  },
};
</script>